const Utils = require("common/Utils");

function DownloadsListView(clientConfig, vpnDownloadsView) {
    const self = this;

    const $content = $(require("html!./downloads_list_view.html"));
    const $vpnConfigContent = $content.find("#vpnConfigDownloadsSection");
    const $vpnConfigListview = $vpnConfigContent.find('[data-role="listview"]');
    const $vpnConfigMessage = $vpnConfigContent.find(".messageText");

    var _downloadType = undefined;

    $content.find(">h3").text($.t("web::downloads.cudalaunch.title", {clientProductName : Utils.getClientProductName()}));
    $content.find(">.messageText").text($.t("web::downloads.cudalaunch.message", {clientProductName : Utils.getClientProductName()}));

    // Set the localized app store logos
    var lang = clientConfig.getLanguage();

    if (lang.indexOf("-") > 0) {
        lang = lang.substr(0, lang.indexOf("-"));
    }
    $content.find("#appStoreLogo").attr("src", "images/app-store-" + lang + ".svg");
    $content.find("#macAppStoreLogo").attr("src", "images/mac-app-store-" + lang + ".svg");
    $content.find("#playStoreLogo").attr("src", "images/google-play-badge-" + lang + ".png");
    $content.find("#windowsStoreLogo").attr("src", "images/windows-store-" + lang + ".svg");

    /**
     * @override
     * @inheritDoc
     */
    this.getHashName = function() {
        return "DownloadsList";
    };

    /**
     * @override
     * @inheritDoc
     */
    this.getHeaderConfiguration = function() {
        return {
            title : $.t("web::downloads.title"),
            i18n : "web::downloads.title"
        };
    };

    /**
     * @override
     * @inheritDoc
     */
    this.getContent = function() {
        return $content;
    };

    this.resize = function(width, height) {
        $content.height(height);
        $content.width(width);
    };

    this.setVpnConfigurationMessage = function(message) {
        $vpnConfigMessage.text(message);
    };

    this.setVpnConfigurations = function(vpnConfigs, downloadType) {
        _downloadType = downloadType;
        $vpnConfigListview.empty();
        self.removeChildViews();

        // Only show the content if we have some configurations available
        const showConfig = vpnConfigs && Object.keys(vpnConfigs).length > 0;
        $vpnConfigContent.toggle(showConfig);

        if (downloadType === "multiple") {
            self.addChildView(vpnDownloadsView);
        }

        for (var config in vpnConfigs) {
            if (!vpnConfigs.hasOwnProperty(config)) {
                continue;
            }
            const vpnConfig = vpnConfigs[config];
            const link = $("<a>", {text : vpnConfig.name});
            const $li = $("<li>").append(link);

            // Need to link to either .VPN or .mobileconfig or go to new view if both applicable
            if (downloadType === "multiple") {
                link.on("click", function() {
                    self.publishEvent("DownloadsSettingsDelegate", "show-vpn-downloads", {resource : vpnConfig});
                });
            } else {
                const typePath = (downloadType === "mobileconfig") ? "ipsec" : "tina";
                link.attr("href", "/sslvpn_config/vpn/" + typePath + "/" + vpnConfig.id)
                    .attr("rel", "external")
                    .addClass("download");
            }

            $vpnConfigListview.append($li);
        }

        $vpnConfigListview.listview("refresh");
    };

    /**
     * @override
     * @inheritDoc
     */
    this.getDisplayMode = function() {
        return "menu";
    };

    /**
     * @override
     * @inheritDoc
     */
    this.requiresAuthentication = function() {
        return false;
    };

    /**
     * @override
     * @inheritDoc
     */
    this.isLeafView = function() {
        return (_downloadType === undefined || _downloadType !== "multiple");
    };
}

DownloadsListView.prototype = require("common/AbstractView");

module.exports = DownloadsListView;